/** ******************************
xFastGrid
written by Genys, Renatas & Danielius
2015.11.24 @ Lexita

v.0.5.1 09.29 13:00
**********************************/
(function($) {
    // kad galima būtų pagauti show ir hide eventus
    $.each(['show', 'hide'], function(i, ev) {
        var el = $.fn[ev];
        $.fn[ev] = function() {
            this.trigger(ev);
            return el.apply(this, arguments);
        };
    });
})(jQuery);

jQuery.expr[':'].contains = function(a, i, m) {
    var hay = jQuery(a)
        .text()
        .toLowerCase()
        .translate_lt();
    var needle = m[3].toLowerCase().translate_lt();

    return hay.indexOf(needle) >= 0;
};

$.fn.activate = function(activeClass) {
    if (activeClass === undefined) activeClass = 'active';
    return this.addClass(activeClass)
        .siblings()
        .removeClass(activeClass)
        .end();
};

/**
 * Grąžina artimiausią tėvą, kuris turi plotį. (Yra matomas).
 * @param {boolean} [withStartingElement]
 * @param {number} [minimumWidth]
 * @return {JQueryElement}
 */
$.fn.closestVisible = function(withStartingElement = false, minimumWidth = 0) {
    let collection =
        withStartingElement === true
            ? this.parents().addBack()
            : this.parents().addBack([]); // [], kad palaikytų vientisą rikiavimą

    return collection.filter((i, el) => el.offsetWidth > minimumWidth).last();
};

(function($) {
    $.fn.xGrid = function(options) {
        var $grid = this, // jquery obj
            grid;

        if ($grid.length === 0) {
            throw new Error(
                'XGRID | Elementas ' + ($grid.selector || '') + ' neegzistuoja.'
            );
        }

        if ($grid[0].xgrid) {
            return $grid[0].xgrid;
        }

        if (options.template === true) {
            grid = new xgrid_template().init($grid, options);
        } else if (options.config.frozen && options.config.frozen > 0) {
            grid = new xgrid_frozen().init($grid, options);
        } else if (options.config.grouping) {
            grid = new xgrid_grouping().init($grid, options);
        } else {
            grid = new xgrid2().init($grid, options);
        }

        $grid[0].xgrid = grid;
        $grid[0].gridas = grid;

        return grid;
    };

    $.fn.xGridPivot = function(options) {
        return new xgrid_pivot().init(this, options);
    };

    $.fn.xGridTemplate = function(options) {
        return new xgrid_template().init(this, options);
        // $(this).xGrid(options); //laikina, reikia naikinti xbug
    };
})(jQuery);
